import {Box, Modal, Container, Grid, Paper, Button, Typography, TextField} from "@mui/material";
import {addDays, addMonths, format} from "date-fns";
import React, {useState} from "react";
import {Outlet, useRouteLoaderData} from "react-router-dom"
import CalendarTableSingle from "../../../components/calendarSingle";
import {uk} from 'date-fns/locale/uk';
import {DateRangePicker} from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import DoneIcon from '@mui/icons-material/Done';
import PageTitle from "../../../components/PageTitle";


export default function ObjectCalendar() {
    const obj = useRouteLoaderData('obj_layout');
    obj.hotelObj.ctype = 'hotel';
    obj.hotelObj.children_obj?.forEach(el => el.ctype = 'hotel_children')
    //console.log(obj);
    const date_range = useState({
        startDate: new Date(),
        endDate: addMonths(new Date(), 3),
        key: 'selection',
    });
    //console.log(obj)

    return (
        <>
            <PageTitle title={`Календар об'єкта: ${obj?.hotelObj?.name || obj?.id || "ID"}`} />
            <Box sx={{width: '100%'}}>
                <DateRangeComponent dateRange={date_range}/>
                <Box sx={{maxWidth: '100%', overflow: 'auto'}}>
                    <CalendarTableSingle
                        data={[obj.hotelObj]}
                        startDate={date_range[0].startDate}
                        endDate={date_range[0].endDate}/>
                </Box>
            </Box>
            <Outlet/>
        </>)
}

const DateRangeComponent = ({dateRange}) => {
    const [selectionRange, setSelectionRange] = dateRange;

    const handleSelectDateRange = (ranges) => {
        setSelectionRange(ranges.selection);
    };

    const [showRangeModal, setShowRangeModal] = useState(false);
    const handleModalRangePicker = () => {
        setShowRangeModal(prev => !prev);
    }

    const daysShort = {
        пон: 'пн',
        вів: 'вт',
        сер: 'ср',
        чтв: 'чт',
        птн: 'пт',
        суб: 'сб',
        нед: 'нд',
    };

    const isMobile = window.innerWidth <= 768; // Определение мобильного устройства

    const customLocale = {
        ...uk,
        localize: {
            ...uk.localize,
            day: (narrowDay, {width}) => {
                const daysShort = {
                    Mon: 'пн',
                    Tue: 'вт',
                    Wed: 'ср',
                    Thu: 'чт',
                    Fri: 'пт',
                    Sat: 'сб',
                    Sun: 'нд',
                };
                return width === 'abbreviated' ? daysShort[format(addDays(new Date(), narrowDay), 'eee')] : uk.localize.day(narrowDay, {width});
            },
        },
    };

    return (
        <>
            <TextField
                label='Період'
                value={`${daysShort[format(selectionRange.startDate, 'eee', {locale: uk})]}, ${format(selectionRange.startDate, 'dd MMM', {locale: uk})} - ${daysShort[format(selectionRange.endDate, 'eee', {locale: uk})]}, ${format(selectionRange.endDate, 'dd MMM', {locale: uk})}`}
                onClick={handleModalRangePicker}
            />
            <Modal
                open={showRangeModal}
                className='flex abs-center'
            >
                <Container maxWidth='md' className='flex' sx={{height: 'fit-content'}}>
                    <Grid item container className='flex abs-center' component={Paper}
                          sx={{p: '20px', height: '100%', overflowY: 'auto'}}>
                        <div
                            style={{
                                maxWidth: '100%',
                                overflowX: 'auto',
                                width: isMobile ? '100%' : 'auto', // Адаптация для мобильных устройств
                                height: isMobile ? '100%' : 'auto'
                            }}
                        >
                            <DateRangePicker
                                ranges={[selectionRange]}
                                onChange={handleSelectDateRange}
                                locale={customLocale}
                                showSelectionPreview={false}
                                months={2}
                                direction={isMobile ? 'vertical' : 'horizontal'} // Вертикально на мобильных
                                minDate={new Date()} // Запрещаем выбор дат до текущей
                            />
                        </div>
                            <Button fullWidth
                                    variant='contained'
                                    sx={{color: 'white'}}
                                    endIcon={<DoneIcon/>}
                                    color='buttonSuccess'
                                    onClick={handleModalRangePicker}>
                                <Typography>Готово</Typography>
                            </Button>
                    </Grid>
                </Container>
            </Modal>
        </>
)
}
